import script from "./upload.vue?vue&type=script&setup=true&lang=js"
export * from "./upload.vue?vue&type=script&setup=true&lang=js"

import "./upload.vue?vue&type=style&index=0&id=dff2fd6a&lang=scss&scoped=true"
import "./upload.vue?vue&type=style&index=1&id=dff2fd6a&lang=scss"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dff2fd6a"]])

export default __exports__